import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import orderService from "../Services/orderService";
import moment from "moment";
import glock from "../Assets/glock.png";
import phone from "../Assets/telephone.png";
import whatsapp from "../Assets/whatsapp.png";
import email from "../Assets/mail.png";
import location from "../Assets/location.png";

// Add numberToWords function from original code
function numberToWords(amount) {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const numToWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " and " + numToWords(n % 100) : "")
      );
    if (n < 1000000)
      return (
        numToWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + numToWords(n % 1000) : "")
      );
    return "";
  };

  const [whole, fraction] = amount.toFixed(2).split(".");
  const words = numToWords(parseInt(whole)) + " Dirhams";
  const paise =
    parseInt(fraction) > 0 ? ` and ${numToWords(parseInt(fraction))} Fils` : "";
  return words + paise + " only";
}

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 40,
    paddingTop: 0,
    paddingBottom: 80,
    position: "relative",
  },
  header: {
    flexDirection: "col",
    justifyContent: "space-between",
    gap: 6,
    paddingBottom: 10,
    paddingTop: 10,
  },
  logocontainer: {
    width: "100%",
    backgroundColor: "black",
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 250,
  },
  footer: {
    position: "absolute",
    bottom: 30,
    left: 40,
    right: 40,
    borderTop: "1px solid #000",
    paddingTop: 10,
    textAlign: "center",
  },
  companyDetails: {
    marginTop: 40, // Reduced margin
    marginBottom: 20,
    border: "1px solid #000",
    padding: 10,
  },
  tableHeader: {
    position: "",
    top: 0, // Position below company details
    left: 40,
    right: 40,
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    padding: 5,
    zIndex: 1,
  },
  tableContent: {
    marginTop: 10, // Space for header + company details + table header
  },
  tableRow: {
    flexDirection: "row",
  },
  col1: {
    width: "5%",
    fontSize: 8,
    padding: 4,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  col2: {
    width: "15%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  col3: {
    width: "37%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "left",
  },
  col4: {
    width: "5%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  col5: {
    width: "10%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "right",
  },
  col6: {
    width: "10%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "right",
  },
  col7: {
    width: "8%",
    fontSize: 8,
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#6B7280",
    textAlign: "right",
  },
  col8: {
    width: "10%",
    fontSize: 8,
    padding: 4,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "right",
  },
  totalsSection: {
    marginTop: 20,
    padding: 10,
    border: "1px solid #000",
  },
  txt1: {
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: 12, // equivalent to text-base
    fontWeight: "light", // or use 'normal' if 'light' doesn't work
    textTransform: "uppercase",
  },
  trn: {
    fontSize: 10, // equivalent to text-sm
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    gap: 10,
    marginBottom: 10,
  },
  leftBox: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    padding: 10,
    width: "64%",
    borderRadius: 8,
  },
  rightBox: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    padding: 10,
    width: "35%",
    borderRadius: 8,
    fontSize: 10,
  },
  customerName: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 4,
  },
  text: {
    fontSize: 8,
    marginBottom: 4,
  },
  clientTrn: {
    fontSize: 8,
    fontWeight: "semibold",
    marginTop: 4,
  },
  bold: {
    fontWeight: "bold",
  },
  tableHeader: {
    width: "100%",
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#6B7280", // gray-500
    backgroundColor: "#F3F4F6", // optional light gray
    alignItems: "center",
  },
  headcol1: {
    width: "5%",
    paddingVertical: 4,
    paddingHorizontal: 2,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  headcol2: {
    width: "15%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  headcol3: {
    width: "37%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "left",
  },
  headcol4: {
    width: "5%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  headcol5: {
    width: "10%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  headcol6: {
    width: "10%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "center",
  },
  headcol7: {
    width: "8%",
    padding: 4,
    fontSize: 8,
    borderRightWidth: 1,
    borderColor: "#6B7280",
    textAlign: "right",
  },
  headcol8: { width: "10%", padding: 4, fontSize: 8, textAlign: "center" },
  totalsSection: {
    marginTop: 20,
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
  },
  totalsLeft: {
    width: "60%",
    fontSize: 8,
    gap: 4,
  },
  totalsRightTable: {
    width: "40%",
    fontSize: 8,
  },
  totalsRow: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000",
  },
  totalsCellLeft: {
    width: "50%",
    padding: 4,
    borderRightWidth: 1,
  },
  totalsCellRight: {
    width: "50%",
    padding: 4,
    textAlign: "ri  ght",
  },
  bold: {
    fontWeight: "bold",
  },
  contactRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
  contactItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  contactText: {
    fontSize: 8,
    fontWeight: "500",
  },
  addressRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 4,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  // Header section styling
  headerbox: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    marginVertical: 8,
  },
  headerleftbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "60%",
    border: "1px solid grey",
    borderRadius: "10px",
    gap: 4,
  },
  headerRightbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "38%",
    border: "1px solid grey",
    borderRadius: "10px",
    gap: 3,
  },
  // FOOTER STYLE
  footerBox: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    marginVertical: 8,
  },
  footerLeftbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "60%",
    border: "1px solid grey",
    gap: 4,
  },
  footerRightbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "38%",
    border: "1px solid grey",
    gap: 2,
  },
});

const PageNumber = () => (
  <Text
    style={styles.pageNumber}
    render={({ pageNumber, totalPages }) =>
      `Page ${pageNumber} of ${totalPages}`
    }
    fixed
  />
);

const Watermark = () => (
  <Text
    style={{
      position: "absolute",
      top: "370%",
      left: "20%",
      textAlign: "center",
      transform: "translate(-50%, -50%) rotate(-30deg)",
      opacity: 0.2,
      fontSize: 50,
      fontWeight: "bold",
      color: "#cccccc",
    }}
  >
    Glock Auto Spare Parts
  </Text>
);

const TableHeader = () => (
  <View style={styles.tableHeader} fixed>
    <Text style={styles.headcol1}>S.No</Text>
    <Text style={styles.headcol2}>CODE</Text>
    <Text style={styles.headcol3}>DESCRIPTION</Text>
    <Text style={styles.headcol4}>QTY</Text>
    <Text style={styles.headcol5}>UNIT PRICE</Text>
    <Text style={styles.headcol6}>TOTAL{"\n"}[Excl./ VAT]</Text>
    <Text style={styles.headcol7}>VAT %5</Text>
    <Text style={styles.headcol8}>TOTAL{"\n"}[Inc./ VAT]</Text>
  </View>
);

const InvoiceDocument = ({
  order,
  validItems,
  totalQty,
  totalAmount,
  vatAmount,
  grandTotal,
}) => {
  const processedItems = validItems
    .map((item) => {
      const price = parseFloat(item.invoice_price || 0);
      const quantity = parseInt(item.invoice_quantity || 0, 10);
      const vatPercent = parseFloat(item.vat_percentage || 5);

      return {
        ...item,
        invoice_price: price,
        invoice_quantity: quantity,
        vat_percentage: vatPercent,
      };
    })
    .filter((item) => item.invoice_price > 0 && item.invoice_quantity > 0);
  const isLastPage = processedItems.length === 0;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header} fixed>
          <Watermark />
          <View style={styles.logocontainer}>
            <Image src={glock} style={styles.logo} />
          </View>
          <View style={{ alignItems: "center" }}>
            <Text style={{ fontSize: 12, textTransform: "uppercase" }}>
              TAX INVOICE
            </Text>
            <Text style={{ fontSize: 10, fontWeight: "bold" }}>
              TRN: 104222918500003
            </Text>
          </View>
        </View>

        {/* Customer Details */}
        <View style={styles.headerbox}>
          <View style={styles.headerleftbox}>
            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              {order.customer_company_name}
            </Text>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              {order.customer_address}
            </Text>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              TRN: {order.trn}
            </Text>
          </View>

          <View style={styles.headerRightbox}>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              INV NO: GAP-{order.id}
            </Text>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              DATE: {moment(order.delivery_date).format("DD-MM-YYYY")}
            </Text>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              Terms: {order.terms}
            </Text>
            <Text style={{ fontWeight: "light", fontSize: 10 }}>
              REF NO: {order.reference_no}
            </Text>
          </View>
        </View>

        {/* Table Header Only on First Page */}
        <TableHeader />

        {/* Items List */}
        {processedItems.map((item, index) => {
          const totalExcl = item.invoice_price * item.invoice_quantity;
          const vat = totalExcl * (item.vat_percentage / 100);
          const totalIncl = totalExcl + vat;

          return (
            <View key={index} style={styles.tableRow} wrap={false}>
              <Text style={styles.col1}>{index + 1}</Text>
              <Text style={styles.col2}>{item.vendor_code}</Text>
              <Text style={styles.col3}>{item.title}</Text>
              <Text style={styles.col4}>{item.invoice_quantity}</Text>
              <Text style={styles.col5}>{item.invoice_price.toFixed(2)}</Text>
              <Text style={styles.col6}>{totalExcl.toFixed(2)}</Text>
              <Text style={styles.col7}>{vat.toFixed(2)}</Text>
              <Text style={styles.col8}>{totalIncl.toFixed(2)}</Text>
            </View>
          );
        })}

        {/* Totals Section */}
        {/* Check if this section overflows and push to next page */}
        <View style={styles.footerBox} wrap={false}>
          <View style={styles.footerLeftbox}>
            <Text style={{ fontSize: 10, fontWeight: "bold" }}>
              Total Quantity: {totalQty}
            </Text>
            <Text style={{ fontSize: 10, fontWeight: "semibold" }}>
              Amount in Words:{" "}
              <Text style={{ fontWeight: "light" }}>
                {numberToWords(grandTotal)}
              </Text>
            </Text>
          </View>
          <View style={styles.footerRightbox}>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text style={{ fontSize: 10, fontWeight: "light" }}>Total:</Text>
              <Text style={{ fontSize: 10, fontWeight: "light" }}>
                {totalAmount.toFixed(2)}
              </Text>
            </View>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text style={{ fontSize: 10, fontWeight: "light" }}>
                VAT (5%):
              </Text>
              <Text style={{ fontSize: 10, fontWeight: "light" }}>
                {vatAmount.toFixed(2)}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                fontWeight: "bold",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                Grand Total:
              </Text>
              <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                AED {grandTotal.toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <View style={styles.contactRow}>
            <View style={styles.contactItem}>
              <Image
                src={phone}
                style={{ marginRight: 4, height: 10, width: 10 }}
              />
              <Text style={styles.contactText}>+971 4 2365733</Text>
            </View>
            <View style={styles.contactItem}>
              <Image
                src={whatsapp}
                style={{ marginRight: 4, height: 10, width: 10 }}
              />
              <Text style={styles.contactText}>+971 54 5857698</Text>
            </View>
            <View style={styles.contactItem}>
              <Image
                src={email}
                style={{ marginRight: 4, height: 10, width: 10 }}
              />
              <Text style={styles.contactText}>sajidsaeed2026@gmail.com</Text>
            </View>
          </View>
          <View style={styles.addressRow}>
            <Image
              src={location}
              style={{ marginRight: 4, height: 10, width: 10 }}
            />
            <Text style={styles.contactText}>
              Naif Arcade, Shop No.2, Street No 125, Al Nakheel Street, Near
              Deira Park Hotel, Deira, Dubai, U.A.E
            </Text>
          </View>
        </View>
        <PageNumber />
      </Page>
    </Document>
  );
};

const InvoiceGenerator = () => {
  const [searchParams] = useSearchParams();
  const invoiceParam = searchParams.get("invoice");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await orderService.fetchByInvoice(invoiceParam);
        setOrder(response.order);
      } catch (error) {
        console.error("Failed to fetch order", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (invoiceParam) fetchOrder();
  }, [invoiceParam]);

  const handleGeneratePDF = async () => {
    if (!order) return;

    // Process items and calculate totals
    const validItems = order.details
      .filter((item) => item.invoice_price && item.invoice_quantity)
      .map((item) => ({
        ...item,
        invoice_price: parseFloat(item.invoice_price),
        invoice_quantity: parseInt(item.invoice_quantity, 10),
        vat_percentage: parseFloat(item.vat_percentage),
      }));

    const totalQty = validItems.reduce(
      (sum, item) => sum + item.invoice_quantity,
      0
    );
    const totalAmount = validItems.reduce(
      (sum, item) => sum + item.invoice_price * item.invoice_quantity,
      0
    );
    const vatAmount = validItems.reduce(
      (sum, item) =>
        sum +
        (item.invoice_price * item.invoice_quantity * item.vat_percentage) /
          100,
      0
    );
    const grandTotal = totalAmount + vatAmount;

    try {
      const blob = await pdf(
        <InvoiceDocument
          order={order}
          validItems={validItems}
          totalQty={totalQty}
          totalAmount={totalAmount}
          vatAmount={vatAmount}
          grandTotal={grandTotal}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("PDF generation failed:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  if (loading) return <div>Loading invoice...</div>;
  if (error || !order) return <div>Error loading invoice data</div>;

  return (
    <div className="">
      <button onClick={handleGeneratePDF} className="button-primary">
        Generate PDF Invoice
      </button>
    </div>
  );
};

export default InvoiceGenerator;
